import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { LocalScheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "laravel"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // laravel
  $auth.registerStrategy('laravel', new LocalScheme($auth, {
  "token": {
    "property": "token",
    "global": false,
    "required": true,
    "type": "Bearer"
  },
  "user": {
    "property": "",
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "https://api.rheinwelten.app/api/token/auth",
      "method": "post"
    },
    "logout": {
      "url": "https://api.rheinwelten.app/api/token/auth",
      "method": "post"
    },
    "user": {
      "url": "https://api.rheinwelten.app/api/user",
      "method": "get"
    }
  },
  "name": "laravel"
}))

  // social
  $auth.registerStrategy('social', new LocalScheme($auth, {
  "token": {
    "property": "token",
    "global": false,
    "required": true,
    "type": "Bearer"
  },
  "user": {
    "property": "",
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "https://api.rheinwelten.app/api/external-social-login",
      "method": "post"
    },
    "user": {
      "url": "https://api.rheinwelten.app/api/user",
      "method": "get"
    }
  },
  "name": "social"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
